var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 300,
    viewBox: "0 0 255 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94553 186.855L166.027 -29.2435C176.676 -43.5292 196.092 -48.0224 211.934 -39.8672L281.232 -4.19336C293.627 2.1874 297.435 18.1051 289.269 29.4044L257.549 73.2972L227.111 115.416C219.375 117.073 211.099 119.273 202.583 122.001C165.44 133.899 137.818 151.314 140.888 160.9C143.959 170.485 176.559 168.611 213.702 156.713C222.777 153.806 231.284 150.57 238.913 147.199L336.011 176.18C349.259 180.135 355.959 194.882 350.223 207.461L317.984 278.163C310.46 294.663 291.951 303.122 274.551 298.013L16.7922 222.328C1.56623 217.857 -4.53832 199.578 4.94553 186.855Z",
    fill: "#52DEE5",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightBg);
export default __webpack_public_path__ + "static/media/topRightBg.e69a51b5f06a8983c70b63e4657361d6.svg";
export { ForwardRef as ReactComponent };